import React from "react";
import Navbar from "./Pages/Templete/Navbar";
import Hero from "./Pages/Home/Hero";
import Features from "./Pages/Home/Features";
import Screenshots from "./Pages/Home/Screenshots";
import Download from "./Pages/Home/Download";
import FAQ from "./Pages/Home/FAQ";
import Footer from "./Pages/Templete/Footer";
import WhatsAppFloat from "./Pages/Templete/WhatsAppFloat";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Features />
      <Screenshots />
      <Download />
      <FAQ />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
